import { CountryCodes } from '../currency';

const chatSupportCountryCodes = [
  CountryCodes.COLOMBIA,
  CountryCodes.PERU,
  CountryCodes.PORTUGAL,
  CountryCodes.SPAIN,
  CountryCodes.FRANCE
];

export const attachBeacon = (locale: CountryCodes) => {
  if (!chatSupportCountryCodes.includes(locale)) {
    return;
  }

  const hsChatbotScript = document.createElement('script');
  hsChatbotScript.id = 'HS-chatbot-script';
  hsChatbotScript.async = true;
  hsChatbotScript.src = `//js-na1.hs-scripts.com/24272312.js`;

  document.body.appendChild(hsChatbotScript);

  const hsChatbotButton = document.getElementById('hubspot-conversations-iframe');

  if (hsChatbotButton) {
    hsChatbotButton.style.visibility = 'visible';
  }
};

export const tearDownBeacons = () => {
  const hsChatbotScript = document.getElementById('HS-chatbot-script');

  if (hsChatbotScript) {
    hsChatbotScript?.remove();
  }

  const hsChatbotButton = document.getElementById('hubspot-conversations-iframe');

  if (hsChatbotButton) {
    hsChatbotButton.style.visibility = 'hidden';
  }
};
